import React, { PureComponent } from 'react';
import { Modal, Button } from "semantic-ui-react";
import { SemanticModal } from 'flow-core-components-shared';
import PropTypes from "prop-types";
import { translate } from "@flow-frontend-npm/common";
import t from './translations';

/**
 * Simple confirmation dialog.
 * (copied and stripped-down from workflow-based flow-visit-widget-createvisit\src\components\ConfirmationModal.jsx)
 */
class ConfirmationModal extends PureComponent {
    static defaultProps = {
        title: translate(t, 'confirmDialog.title'),
        okColor: 'green',
        cancelText: translate(t, 'confirmDialog.cancel'),
        cancelColor: 'grey'
    };
    
    /**
     * @return  {void}
     */
    handleConfirm = () => {
        this.props.onConfirm(this.props.currentConfirmation);
    };

    /**
     * @return  {void}
     */
    handleCancel = () => {

    };

    /**
     * Renders the modal.
     * @return {boolean|*}
     */
    render = () => (
        <SemanticModal open={!!this.props.currentConfirmation} onClose={this.props.onCancel}>
            <Modal.Header>{this.props.title}</Modal.Header>
            {this.props.dialogText && <Modal.Content>{this.props.dialogText}</Modal.Content>}
            <Modal.Actions>
                <Button data-id='confirmation:ok' color={this.props.okColor}
                    onClick={this.handleConfirm}>{this.props.okText}</Button>
                <Button data-id='confirmation:cancel' color={this.props.cancelColor}
                    onClick={this.props.onCancel}>{this.props.cancelText}</Button>
            </Modal.Actions>
        </SemanticModal>
    );
}
ConfirmationModal.propTypes = {
    currentConfirmation: PropTypes.any,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    title: PropTypes.string,
    dialogText: PropTypes.string,
    okText: PropTypes.string,
    okColor: PropTypes.string,
    cancelText: PropTypes.string,
    cancelColor: PropTypes.string
};

export default ConfirmationModal;
